import React from 'react';
import { GalleryImage, galleryAPI } from '../../services/galleryApi';
import toast from 'react-hot-toast';
import { TrashIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';

interface ImageTileProps {
  image: GalleryImage;
  onDeleteSuccess?: (imageId: string) => void;
  canDelete?: boolean; // Prop to control delete button visibility
}

const ImageTile: React.FC<ImageTileProps> = ({ image, onDeleteSuccess, canDelete = false }) => {
  const handleCopyUrl = () => {
    navigator.clipboard.writeText(image.url);
    toast.success('URL de l\'image copiée !');
  };

  const handleDelete = async () => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette image ?')) {
      try {
        await galleryAPI.deleteGalleryImage(image._id);
        toast.success('Image supprimée avec succès !');
        onDeleteSuccess?.(image._id);
      } catch (error) {
        console.error('Failed to delete image:', error);
        toast.error('Erreur lors de la suppression de l\'image.');
      }
    }
  };

  return (
    <div className="relative group aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-lg bg-gray-100 shadow-md">
      <img
        src={image.url}
        alt={image.filename}
        className="object-cover object-center w-full h-full"
      />
      <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <button
          onClick={handleCopyUrl}
          className="m-2 p-2 rounded-full bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          title="Copier l'URL"
        >
          <DocumentDuplicateIcon className="h-5 w-5" />
        </button>
        {canDelete && (
          <button
            onClick={handleDelete}
            className="m-2 p-2 rounded-full bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            title="Supprimer l'image"
          >
            <TrashIcon className="h-5 w-5" />
          </button>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-2 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <p className="truncate">{image.filename}</p>
        {image.serviceType && <p className="truncate">Type: {image.serviceType.name}</p>}
        {image.serviceSubType && <p className="truncate">Sous-type: {image.serviceSubType.name}</p>}
      </div>
    </div>
  );
};

export default ImageTile;
